import { StanModal } from '@/components';

interface DeleteCustomerModalProps {
    isOpen: boolean;
    customerName: string;
    hasActiveSubscription: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
}

export function DeleteCustomerModal({
    isOpen,
    customerName,
    hasActiveSubscription,
    onClose,
    onConfirm,
    isLoading = false,
}: DeleteCustomerModalProps) {
    const bodyText = hasActiveSubscription
        ? `${customerName} has active subscription(s). Just confirming that you want to delete them. This action cannot be undone.`
        : `Just confirming that you want to delete ${customerName}. This action cannot be undone.`;

    return (
        <StanModal
            id='delete-customer-modal'
            isOpen={isOpen}
            title='Are you sure?'
            primaryActionLabel='Delete Customer'
            primaryActionColor='destructive'
            primaryActionLoading={isLoading}
            secondaryActionLabel='Cancel'
            onPrimaryAction={onConfirm}
            onSecondaryAction={onClose}
            onClose={onClose}
            aria-label='Confirm customer deletion'
        >
            <p className='text-gray caption-1-bold text-center'>{bodyText}</p>
        </StanModal>
    );
}
